// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".q-header .q-toolbar{height:40px;min-height:42px}.q-header{background:radial-gradient(circle,#005cdb,48%,#291d71 66%)}@media (max-width:768px){.q-header{background:radial-gradient(circle,#0069f7,63%,#332394 100%)}}.q-header:hover{box-shadow:0 12px 20px rgba(26,109,217,.35)}.q-toolbar-title{font-size:22px;font-weight:700}.q-header .q-btn{font-size:20px}.q-header .text-weight-medium{font-size:18px}.q-header .text-caption{font-size:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
